import type { Template } from "@/types";

export const LA_03_H2_V1: Template[] = [
    {
        id: "la-03-h2v1-01",
        name: "LA 01 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h2_v1_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 199, y: 34, width: 277, height: 415, rotation: 0, imageRotation: 0 },
            { id: "2", x: 852, y: 34, width: 325, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 852, y: 246, width: 325, height: 204, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-02",
        name: "LA 02 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h2_v1_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 202, y: 38, width: 271, height: 407, rotation: 0, imageRotation: 0 },
            { id: "2", x: 717, y: 139, width: 294, height: 206, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1019, y: 139, width: 293, height: 206, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-03",
        name: "LA 03 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h2_v1_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 47, y: 37, width: 281, height: 408, rotation: 0, imageRotation: 0 },
            { id: "2", x: 985, y: 37, width: 320, height: 201, rotation: 0, imageRotation: 0 },
            { id: "3", x: 985, y: 246, width: 320, height: 200, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-04",
        name: "LA 04 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h2_v1_04.png",
        size: [1352, 483],
        style: {},
        slots: [        
            { id: "1", x: 175, y: 34, width: 325, height: 204, rotation: 0, imageRotation: 0 },
            { id: "2", x: 175, y: 246, width: 325, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 876, y: 34, width: 277, height: 415, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-05",
        name: "LA 05 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h2_v1_05.png",
        size: [1352, 483],
        style: {},
        slots: [    
            { id: "1", x: 40, y: 139, width: 293, height: 206, rotation: 0, imageRotation: 0 },
            { id: "2", x: 341, y: 139, width: 294, height: 206, rotation: 0, imageRotation: 0 },
            { id: "3", x: 879, y: 38, width: 271, height: 407, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-06",
        name: "LA 06 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h2_v1_06.png",
        size: [1325, 473],
        style: {},
        slots: [
            { id: "1", x: 0, y: 58, width: 526, height: 358, rotation: 0, imageRotation: 0 },
            { id: "2", x: 534, y: 58, width: 259, height: 358, rotation: 0, imageRotation: 0 },      
            { id: "3", x: 801, y: 58, width: 524, height: 358, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-07",
        name: "LA 07 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h2_v1_07.png",
        size: [1325, 473],
        style: {},
        slots: [
            { id: "1", x: 62, y: 75, width: 476, height: 324, rotation: 0, imageRotation: 0 },
            { id: "2", x: 546, y: 75, width: 234, height: 324, rotation: 0, imageRotation: 0 },      
            { id: "3", x: 788, y: 75, width: 475, height: 324, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-08",
        name: "LA 08 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h2_v1_08.png",
        size: [1325, 473],
        style: {},
        slots: [          
            { id: "1", x: 0, y: 58, width: 526, height: 358, rotation: 0, imageRotation: 0 },
            { id: "2", x: 534, y: 58, width: 525, height: 358, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1067, y: 58, width: 258, height: 358, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-09",
        name: "LA 09 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h2_v1_09.png",
        size: [1325, 473],
        style: {},
        slots: [
            { id: "1", x: 62, y: 75, width: 234, height: 324, rotation: 0, imageRotation: 0 },          
            { id: "2", x: 304, y: 75, width: 476, height: 324, rotation: 0, imageRotation: 0 },
            { id: "3", x: 788, y: 75, width: 475, height: 324, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-10",
        name: "LA 10 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-03-h2_v1_10.png",
        size: [1325, 473],
        style: {},
        slots: [         
            { id: "1", x: 62, y: 75, width: 476, height: 324, rotation: 0, imageRotation: 0 },
            { id: "2", x: 546, y: 75, width: 476, height: 324, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1030, y: 75, width: 233, height: 324, rotation: 0, imageRotation: 0 }
        ],
    }

];
